<template>
  <div class="flex-col">
    <b-tabs type="is-boxed" v-model="mainActiveTab">

      <b-tab-item>
        <template slot="header">
          <b-icon pack="fas" icon="tasks"></b-icon>
          <span> {{ project.name }} </span>
        </template>
        <div>

          <div class="flex justify-end" v-if="isWhitelistedCompany">
            <div class="flex w-7/8">
              <b-tooltip :label="txtTooltipExport || this.$t('export')" position="is-left">
                <div class="rounded-full bg-blue w-8 h-8 flex ml-3 items-center justify-center text-grey-lightest cursor-pointer" @click="exportReport">
                  <b-icon icon="download" pack="fas" size="is-small" v-if="! isLoadingExport" />
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-spin"
                    v-if="isLoadingExport"
                    >
                  </b-icon>
                </div>
              </b-tooltip>
            </div>
          </div>


          <!-- Seccion de Extrafields -->
          <div class="w-full panel" v-if="isWhitelistedCompany">
            <div class="flex">
              <div class="flex flex-wrap w-full">
                <div v-for="extrafield in dataExtrafields" :key="'extrafield_' + extrafield.id" class="flex flex-col w-1/4">
                  <div class="w-full text-black font-bold">{{ extrafield.field.name }}</div>
                  <div class="w-full">{{ extrafield.value_free ? extrafield.value_free : '--' }}</div>
                </div>
                <div v-if="!extrafieldsFound" class="w-full text-center">No extrafields found</div>
              </div>
            </div>
          </div>


          <!-- Panel 2  BARRAS GRUPOS -->
          <div class="w-full mt-4 panel">
            <div class="flex flex-row w-full text-blue font-bold">{{ $t('current_progress') }}</div>
            <div class="flex flex-row w-full relative">
              <!--  <div v-if="isLoadingPanels" class="w-full relative text-center"> -->
                <b-loading :is-full-page="false" v-model="isLoadingPanels" :can-cancel="false"></b-loading>
              <!-- </div> -->
              <bar-chart :data="groupsChartsCombined" suffix="%" :min="0" :max="100" :stacked="false" :download="true" style="height: 500px;" :colors="barChartColors" />
            </div>
          </div>


          <!-- Barras Generales de progreso -->
          <div class="w-full mt-8 panel">
            <div style="width: 100%; text-align: center;">
              <div class="center">
                <label class="font-bold" style="font-size: 12px; color: #444">
                  <div style="height:10px; width: 40px; background: #95a3e0; display: inline-block"></div>
                  Total {{ $t('baseline') }}: {{ totalScheduled }}%
                </label>
                <label class="font-bold" style="font-size: 12px; color: #444">
                  <div style="height:10px; width: 40px; background: #ea9285; display: inline-block"></div>
                  Total {{ $t('inspected') }}: {{ totalProgress }}%
                </label>
                <label class="font-bold" style="font-size: 12px; color: #444" v-if="filters.actual_progress">
                  <div style="height:10px; width: 40px; background: #76cf70; display: inline-block"></div>
                  Total {{ $t('actual') }}: {{ totalProgressReal }}%
                </label>
              </div>
              <div v-if="isLoadingPanels" class="">Loading...</div>
              <div style="width: 100%; background-color: #f3f3f3; border: 1px solid #ddd; border-radius: 5px; margin-top: 5px;">
                <div :style="{ 'width': totalScheduled + '%', 'background-color': '#95a3e0', 'height': 15+'px', 'border-radius': 5+'px'}"></div>
              </div>
              <div style="width: 100%; background-color: #f3f3f3; border: 1px solid #ddd; border-radius: 5px; margin-top: 5px;">
                <div :style="{'width': totalProgress + '%', 'background-color': '#ea9285', 'height': 15+'px', 'border-radius': 5+'px'}"></div>
              </div>
              <div style="width: 100%; background-color: #f3f3f3; border: 1px solid #ddd; border-radius: 5px; margin-top: 5px;"
                   v-if="filters.actual_progress">
                <div :style="{'width': totalProgressReal + '%', 'background-color': '#76cf70', 'height': 15+'px', 'border-radius': 5+'px'}"></div>
              </div>
            </div>
          </div>


          <!-- Tabla resumen progresos grupos -->
          <div class="w-full mt-8 panel relative">
            <b-table
              icon-pack="fas"
              :data="groupsTable"
              :bordered="true"
              :loading="isLoadingPanels"
              >
              <template>
                <b-table-column field="task" cell-class="w-5/12">
                  <template v-slot:header=""><span class="text-xs">{{ $t('task') }}</span></template>
                  <template v-slot="props">{{ props.row.name }}</template>
                </b-table-column>

                <b-table-column field="scheduled_start">
                  <template v-slot:header=""><span class="text-xs">{{ $t('scheduled_start_date') }}</span></template>
                  <template v-slot="props">{{ formatDateCustom(props.row.current_start_date) }}</template>
                </b-table-column>

                <b-table-column field="scheduled_end">
                  <template v-slot:header=""><span class="text-xs">{{ $t('scheduled_end_date') }}</span></template>
                  <template v-slot="props">{{ formatDateCustom(props.row.current_end_date) }}</template>
                </b-table-column>

                <b-table-column field="current_start">
                  <template v-slot:header=""><span class="text-xs">{{ $t('actual_start') }}</span></template>
                  <template v-slot="props">{{ formatDateCustom(props.row.gantt_real_start_date) }}</template>
                </b-table-column>

                <b-table-column field="current_end">
                  <template v-slot:header=""><span class="text-xs">{{ $t('actual_end') }}</span></template>
                  <template v-slot="props">{{ formatDateCustom(props.row.gantt_real_end_date) }}</template>
                </b-table-column>

                <b-table-column field="avance">
                  <template v-slot:header=""><span class="text-xs">% {{ filters.actual_progress ? $t('actual_progress') : $t('progress') }}</span></template>
                  <template v-slot="props">{{ filters.actual_progress ? props.row.progress_real : props.row.progress }}</template>
                </b-table-column>
              </template>

              <template #empty>
                  <div class="has-text-centered">{{ $t('no_results') }}</div>
              </template>
            </b-table>
          </div>

          <!-- Progreso general del proyecto -->
          <div class="panel w-full mt-8">
            <div class="flex flex-row ">
              <div class="flex flex-col w-3/4 text-blue font-bold">% Project Progress</div>
              <div class="flex flex-col w-1/4 text-xs text-right pr-2 m-auto" v-if="projectPredictedEndMonth && isWhitelistedCompany" style="color: orange;">{{ $t('expected_end_date_actual_performance') }}: {{ formatDateCustom(projectPredictedEndMonth) }}</div>
            </div>
            <div class="flex flex-row w-full">
              <div v-if="isLoadingProjectProgress" class="w-full relative flex flex-row text-center" style="height: 80px;">
                <b-loading :is-full-page="false" v-model="isLoadingProjectProgress" :can-cancel="false"></b-loading>
              </div>
              <line-chart v-else :data="projectProgress" :colors="lineChartColors(showActualProgress)" suffix="%"
                :library="{ spanGaps: true,
                    scales: {
                      xAxes: [{
                        type: 'time',
                        time: {
                          tooltipFormat: 'D MMM YYYY',
                          displayFormats: {
                            day: 'D MMM YYYY'
                          }
                        }
                      }]
                    }
                  }"/>
            </div>
          </div>

          <!-- Cost control 1 -->
          <div class="panel w-full mt-8" v-if="showActualProgress">
            <div class="flex flex-row w-full text-blue font-bold">Progress cost estimate</div>
            <div class="flex flex-row w-full">
              <line-chart :data="costControl.cost1" suffix="€"/>
            </div>
          </div>

          <!-- Cost control 2 -->
          <div class="panel w-full mt-8" v-if="showActualProgress">
            <div class="flex flex-row w-full text-blue font-bold">{{ $t('planned_sale') }} / {{ $t('real_sale') }}</div>
            <div class="flex flex-row w-full">
              <line-chart :data="costControl.cost2" suffix="€"/>
            </div>
          </div>

          <!-- Cost control 3 -->
          <div class="panel w-full mt-8" v-if="showActualProgress">
            <div class="flex flex-row w-full text-blue font-bold">{{ $t('planned_cost') }} / {{ $t('real_cost') }} + {{ $t('forecast') }}</div>
            <div class="flex flex-row w-full">
              <line-chart :data="costControl.cost3" suffix="€"/>
            </div>
          </div>

          <!-- Subpanel precio venta. Monetary execution. Unitprice x (scheduled or executed quantity) -->
          <dashboard-subpanel-monetary-executions
            v-if="project && project.id && (company.alias === 'ohla-mexico' || company.alias === 'trial')"
            :project-id="project.id"
            :project-name="project.name"
            :currency="project.currency"
            class="w-full mt-8"
          />

          <!-- Panel 1 Progreso grupos -->
          <!-- <div class="panel w-full mt-8">
            <div class="flex flex-row w-full text-blue font-bold">{{ $t('group_progress') }}</div>
            <div class="flex flex-row w-full">
              <column-chart :data="panel1" suffix="%" :min="0" :max="100"/>
            </div>
          </div> -->


          <!-- Gráficas dinámicas por grupo (con sub-grupos expandibles) -->
          <div class="w-full mt-8" v-for="group in groupChartIndividual" :key="'charset_'+group.id">
            <group-progress-chart
              :group="group"
              :level="0"
              :max-depth="10"
              :main-chart-colors="lineChartColors(showActualProgress)"
              :main-chart-library="mainChartLibrary"
              :show-current-month="true"
              :show-predicted-end-date="isWhitelistedCompany"
              :fetch-children="fetchWlGroupChildren"
            />
          </div>
        </div>
      </b-tab-item>

      <b-tab-item>
        <template slot="header">
          <b-icon pack="fas" icon="tasks"></b-icon>
          <span> {{ $t('project_information') }}</span>
        </template>
        <project-information-panel :panel1="panel1" :export-filename="project.name + '_' + $t('information_per_user')" />
      </b-tab-item>

    </b-tabs>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { quantityDisplayDecimals } from '·/helpers/quantity-display'
  import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
  import VueChartkick from 'vue-chartkick'
  import Chart from 'chart.js'
  import moment from 'moment'
  import excelByActivityGroups from '·/components/reports/excel-by-activity-groups.vue'
  import ProjectInformationPanel from '·/components/dashboard/project-information-panel.vue'
  import GroupProgressChart from '·/components/dashboard/group-progress-chart.vue'
  import DashboardSubpanelMonetaryExecutions from '·/components/dashboard/dashboard-subpanel-monetary-executions.vue'

  Vue.use(VueChartkick, {adapter: Chart})

  export default {
    middleware: 'auth',
    title: 'project_home_page_title',
    subtitle: 'project_home_page_subtitle',
    menuOption: '2-1',

    components: {
      ScaleLoader,
      excelByActivityGroups,
      ProjectInformationPanel,
      GroupProgressChart,
      DashboardSubpanelMonetaryExecutions,
    },

    data: () => ({
      filters: {
        entity_id: 0,
        location_id: 0,
        status_id: 1,
        parent_group_id: null,
        actual_progress: 1,
        baseline: 'initial',
      },
      isLoading: true,
      panel1: {
        info: [],
        users: []
      },
      mainActiveTab: 0,
      options: [],

      isLoadingExport: false,
      txtTooltipExport: null,

      extrafieldsFound: true,

      // paneles
      dataExtrafields: [],
      groupsChartsCombined: [],
      totalScheduled: 0,
      totalProgress: 0,
      totalProgressReal: 0,
      groupsTable: [],
      groupChartIndividual: [],
      projectProgress: [],
      costControl: { cost1: {}, cost2: {}, cost3: {} },
      barChartColors: ['#3366CC', '#DC3913', '#129618'], // colores azul(lineabase), rojo(inspeccionado), verde(real)
      // lineChartColors: ['#3366CC', '#DC3913', '#129618', '#fc8608'], // colores azul(lineabase), rojo(inspeccionado), verde(real), naranja(previsto)
      showActualProgress: true, // por defecto true (welink, tci), false (ignis)

      projectPredictedEndMonth: null, // fecha de finalización prevista del proyecto, cogida de entre la mayor de cada grupo

      isLoadingPanels: true,
      isLoadingProjectProgress: true,
    }),

    computed: {
      ...mapGetters({
        project: 'app/project',
        user: 'auth/user',
        company: 'app/company',
      }),

      isWhitelistedCompany() {
        // return ['welink', 'ohla-mexico'].includes(this.company?.alias);
        return true; // para todos!
      },

      mainChartLibrary() {
        return {
          spanGaps: true,
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'month',
                stepSize: 4,
                minUnit: 'month',
                tooltipFormat: 'D MMM YYYY',
                displayFormats: { month: 'MMM YYYY', day: 'D MMM YYYY' }
              },
              ticks: {
                autoSkip: false,
                maxRotation: 0
              }
            }]
          }
        }
      },
    },

    mounted() {
      this.preparePanel1()

      if (this.project == null) {

        this.$router.push('/projects');

      } else {

        if (! ['welink', 'tci'].includes(this.company.alias)) {
          // dashboard usado tambien en companies sin progreso real (ignis)
          this.filters.actual_progress = 0;
          this.showActualProgress = false;
          this.barChartColors = ['#3366CC', '#DC3913']; // quitamos el color verde (progreso real)
          // this.lineChartColors = ['#3366CC', '#DC3913', '#fc8608']; // tambien quita verde
        }

        // loadAllCurrentMonth reutiliza el cache de getMegaDataSet rellenado por wlgrouppanel;
        // si van en paralelo ambos fallan cache y duplican el trabajo pesado.
        this.loadRootGroupsLive().finally(() => this.loadAllCurrentMonth());
        this.getPanels();

        const deferSecondary = () => {
          this.getDataExtrafields()
          this.getPanel1()
          this.getPanelsCostControl()
          // this.getProgressPerGroup(); // se decidió ocultar este panel
          // this.getProgressProject(); // anulado muy lento. se calcula en funcion de cada grupo
        }
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(deferSecondary, { timeout: 1500 })
        } else {
          setTimeout(deferSecondary, 200)
        }

        let pageInfo = {
          title: this.project.name,
          subtitle: this.$t('project_home_page_subtitle'),
          menuOption: '2-1',
        }

        this.$store.dispatch('app/updatePageInfo', {info: pageInfo})
      }
    },

    methods: {

      preparePanel1() {
        this.panel1.info = [
          {
            "name": this.$t('activity').toUpperCase(),
            "total": 0
          },
          {
            "name": this.$t('measurements_loaded').toUpperCase(),
            "total": 0
          },
          {
            "name": this.$t('issues').toUpperCase(),
            "total": 0
          },
          {
            "name": this.$t('flows_created').toUpperCase(),
            "total": 0
          },
          {
            "name": this.$t('uploaded_images').toUpperCase(),
            "total": 0
          },
          {
            "name": this.$t('uploaded_documents').toUpperCase(),
            "total": 0
          },
          {
            "name": this.$t('comments').toUpperCase(),
            "total": 0
          }
        ]
      },

      async getPanel1() {
        let self = this
        let url = '/api/v2/project/' + this.project.id + '/dashboard/photovoltaicpanel1';
        await axios.get(url, {params: this.filters})
          .then(response => {
            self.panel1 = response.data.data
          })
          .catch((error) => {
            self.$notify.error(error.error_msg || 'error_retrieving_data')
          });
      },

      async getDataExtrafields() {
        let self = this
        let url = '/api/v2/project/' + this.project.id + '/dashboard/wlextrafields';
        await axios.get(url, {params: this.filters})
          .then(response => {
            self.dataExtrafields = response.data.data
            self.extrafieldsFound = self.dataExtrafields.length > 0
          })
          .catch((error) => {
            self.$notify.error(error.error_msg || 'error_retrieving_data')
          });
      },

      // Para antiguo grafico de barras con progreso de cada grupo. (ocultado por ahora)
      // async getProgressPerGroup() {
      //   let self = this
      //   let url = '/api/v2/project/' + this.project.id + '/dashboard/wlgroupprogress';
      //   await axios.get(url, {params: this.filters})
      //     .then(response => {
      //       self.panel1 = response.data.data
      //     })
      //     .catch((error) => {
      //       self.$notify.error(error.error_msg || 'error_retrieving_data')
      //     });
      // },

      // wlpanels alimenta bar chart, tabla y totales. Las gráficas históricas por
      // grupo NO se rellenan aquí: lo hace loadRootGroupsLive en paralelo.
      async getPanels() {
        let self = this
        self.isLoadingPanels = true;
        let url = '/api/v2/project/' + this.project.id + '/dashboard/wlpanels';

        await axios.get(url, {params: this.filters})
          .then(response => {
            self.groupsChartsCombined = response.data.data.groupsChartsCombined
            self.totalScheduled = response.data.data.totalScheduled
            self.totalProgress = response.data.data.totalProgress
            self.totalProgressReal = response.data.data.totalProgressReal
            self.groupsTable = response.data.data.groupsTable
            self.isLoadingPanels = false
          })
          .catch((error) => {
            console.log('Error in getPanels', error, error.error_msg)
            self.$notify.error(error.error_msg || 'error_retrieving_data')
          });
      },

      async loadRootGroupsLive() {
        let url = '/api/v2/project/' + this.project.id + '/dashboard/wlgrouppanel'
        const params = { ...this.filters }
        delete params.entity_id
        delete params.parent_group_id
        if (['elecnor1'].includes(this.company.alias)) {
          params.predictionType = 'spi'
        }

        try {
          const response = await axios.get(url, { params })
          const groups = Array.isArray(response.data.data) ? response.data.data : []

          this.groupChartIndividual = groups.map(g => ({
            ...g,
            dataset: g.data,
            // datasetCurrentMonth llega después vía loadAllCurrentMonth.
            datasetCurrentMonth: [],
            pendingLoad: false,
          }))

          // PARA TESTEAR //5385
          // this.groupChartIndividual = [
          //   { id: 5672, name: "PERMITTING", dataset:	[], pendingLoad: true, },
          //   { id: 5768, name: "CONSTRUCTION", dataset:	[], pendingLoad: true, },
          // ]

          // % Project Progress se recalcula desde cero cada vez que entran groups nuevos.
          this.projectProgress = []
          groups.forEach(g => this.calculateProjectProgress(g.weight, g.data))
          this.sumUpProjectProgress()

          this.projectPredictedEndMonth = groups.reduce(
            (acc, g) => this.getMaxDate(acc, g.predictedEndMonth),
            null
          )
          this.isLoadingProjectProgress = false
        } catch (error) {
          console.log('Error in loadRootGroupsLive', error)
          this.$notify.error(error.error_msg || 'error_retrieving_data')
        }
      },

      // dataCurrentMonth de todos los root groups en una request.
      // Se dispara tras loadRootGroupsLive para reaprovechar el cache de wlgrouppanel.
      async loadAllCurrentMonth() {
        let url = '/api/v2/project/' + this.project.id + '/dashboard/wlcurrentmonthbulk'
        const params = { ...this.filters }
        delete params.entity_id
        delete params.parent_group_id
        if (['elecnor1'].includes(this.company.alias)) {
          params.predictionType = 'spi'
        }

        try {
          const response = await axios.get(url, { params })
          const dataByGroup = response.data.data || {}

          this.groupChartIndividual.forEach(g => {
            if (dataByGroup[g.id]) {
              g.datasetCurrentMonth = this.processDataCurrentMonth(dataByGroup[g.id])
            }
          })
        } catch (error) {
          console.log('Error in loadAllCurrentMonth', error)
        }
      },

      lineChartColors(withActualProgress) {
        // caso normal: azul (linea base), rojo (ejecutado), verde? (progreso real?), naranja (previsto)
        // con lineabase inicial: azul (linea base inicial), purple (linea base actual), rojo (ejecutado), verde? (progreso real?), naranja (previsto)
        let chartColors = ['#284ec0'] // blue
        if (this.filters.baseline == 'initial') {
          chartColors.push('#8c1a94') // purple
        }
        chartColors.push('#d12411') // red
        if (withActualProgress) {
          chartColors.push('#449431') // green
        }
        chartColors.push('#fc8608') // orange
        return chartColors
      },

      // Lazy-load de sub-grupos al expandir un grupo en group-progress-chart.
      // Trae todos los hijos en una sola llamada (backend devuelve array si no se manda entity_id).
      async fetchWlGroupChildren(parentId) {
        const params = { ...this.filters, parent_group_id: parentId }
        // estos proyectos llevan otro tipo de prediccion
        if (['elecnor1'].includes(this.company.alias)) {
          params['predictionType'] = 'spi'
        }
   
        delete params.entity_id

        try {
          const { data } = await axios.get('/api/v2/project/' + this.project.id + '/dashboard/wlgrouppanel', { params })
          const groups = Array.isArray(data.data) ? data.data : [data.data]
          return groups.map(g => ({
            ...g,
            dataset: g.data,
            datasetCurrentMonth: this.processDataCurrentMonth(g.dataCurrentMonth),
          }))
        } catch (error) {
          this.$notify.error(error.error_msg || 'error_retrieving_data')
          return []
        }

      },


      // a partir de los datos de cada grupo, calculamos el progreso del proyecto (ahorramos calcular tooodo el proyecto)
      // recibe la ponderacion del grupo en el proyecto y el dataset del grupo.
      // Usa 'dataRaw' que tiene los avances en cada mes, si acumular. Se hará un acumulado de cada mes al final una vez recolectados toodos los datos, si se hace antes se altera el resultado
      calculateProjectProgress(weight, dataset) {

        try {
          let tmpDataset = dataset.filter(chartLine => (chartLine.name != 'Previsto' && chartLine.name != 'Forecast')) // en grafica conjunta de project no hay previsto
          tmpDataset.forEach(chartLine => {
            // console.log('Ponderacion '+weight+'. Procesando ', chartLine.name, " que tiene ", Object.keys(chartLine.data).length, " items")

            if (chartLine.dataRaw == null) {
              chartLine.dataRaw = {} // avoid typeError null to object conversion, abajo en Object.keys(null)
            }

            Object.keys(chartLine.dataRaw).forEach(month => {

              // console.log('procesando mes ', month, ' que tiene valor ', chartLine.data[month])

              // ese valor de ese mes representa el avance en el grupo. Lo multiplicamos por el peso del grupo en el proyecto
              let monthValueInProject = chartLine.dataRaw[month] * weight / 100

              // buscamos en grafico proyecto la linea del grafico que estamos procesando (linea base, inspeccionado, real, previsto )
              let projectChartLine = this.projectProgress.find(itemLine => itemLine.name == chartLine.name)
              if (projectChartLine == undefined) {
                this.projectProgress.push({name: chartLine.name, data: {}}) // si no encuentra la inserta
                projectChartLine = this.projectProgress.find(itemLine => itemLine.name == chartLine.name) // y la vueve a buscar para que el objeto apunte ahi
              }

              // ahora vemos si en esta linea (linea base o inspeccionado, etc) ya habia un valor para ese mes
              let projectMonthValue = Object.keys(projectChartLine.data).find(projectMonth => projectMonth == month)
              if (projectMonthValue == undefined) {
                projectChartLine.data[month] = monthValueInProject
              } else {
                projectChartLine.data[month] += monthValueInProject
              }
            })
          })
        } catch (error) {
          console.log('Error in calculateProjectProgress', error)
        }

      },


      // Acumula los valores de cada mes con los de los meses anteriores para dar progreso acumulado
      sumUpProjectProgress() {
        this.projectProgress.forEach(chartLine => {
          let accum = 0
          // hacemos un sort por si hay meses desordenados (firefox los muestra en su posicion ordinal en el array, en vez de en su posicion cronologica)
          Object.keys(chartLine.data).sort().forEach(month => {
            accum += chartLine.data[month]
            chartLine.data[month] = parseFloat(accum.toFixed(quantityDisplayDecimals(this.project)))
          })
        })
      },


      // Recibe el dataset del mes actual y lo transforma para la grafica
      // separando en 2 lineas (Inspeccionado y Real)
      processDataCurrentMonth(dataCurrentMonth) {
        try {
          let data = [];
          let dataExecuted = {};
          let dataActual = {};

          Object.keys(dataCurrentMonth).forEach(day => {
            dataExecuted[day] = dataCurrentMonth[day].percent_executed_accum
            dataActual[day] = dataCurrentMonth[day].percent_executed_actual_accum
          })

          let labelExe = this.filters.actual_progress ? this.$t('inspected') : this.$t('executed1');

          data.push({name: labelExe, data: dataExecuted})
          if (this.filters.actual_progress) { // si no se pide el real no lo añadimos
            data.push({name: this.$t('actual'), data: dataActual})
          }

          return data;

        } catch (error) {
          console.log('Error in processDataCurrentMonth', error)
        }
      },


      // Anulado, muuuy lento. Se calcula en funcion de cada grupo
      async getProgressProject() {
        let self = this
        let url = '/api/v2/project/' + this.project.id + '/dashboard/wlprojectprogress';
        await axios.get(url, {params: this.filters})
          .then(response => {
            self.projectProgress = response.data.data
          })
          .catch((error) => {
            self.$notify.error(error.error_msg || 'error_retrieving_data')
          });
        self.isLoadingProjectProgress = false;
      },


      async getPanelsCostControl() {

        if (! this.showActualProgress) {
          return; // si no es welink/tci no hacemos nada
        }

        let self = this
        let url = '/api/v2/project/' + this.project.id + '/dashboard/wlcostcontrol';
        await axios.get(url, {params: this.filters})
          .then(response => {
            self.isLoading = false;
            self.costControl.cost1 = response.data.data.cost1
            self.costControl.cost2 = response.data.data.cost2
            self.costControl.cost3 = response.data.data.cost3
          })
          .catch((error) => {
            self.$notify.error(error.error_msg || 'error_retrieving_data')
          });

      },


      formatDate(date) {
        return moment(date).format('HH:mm (DD-MM)'); //'DD-MM-YYYY HH:mm'
      },


      async exportReport() {

        if( !this.isLoadingExport ){
          this.txtTooltipExport = this.$t('generating');

          this.$notify.success('generating_report');
          this.isLoadingExport = true;
          let self = this
          let url = '/api/v2/project/' + this.project.id + '/dashboard/wldashboardreport';
          await axios.get(url, {params: this.filters})
            .then(response => {
              window.open(response.data.data);

              self.$notify.success('report_generated')
              self.isLoadingExport = false;
              self.txtTooltipExport = this.$t('export')
            })
            .catch((error) => {
              //Se produjo un error
              console.log("Error loading exportación")
              self.$notify.error(error.error_msg || 'error_retrieving_data')
              self.isLoadingExport = false
              self.txtTooltipExport = this.$t('export')
            });
        }
      },


      formatDateCustom(dateString) {
        if (!dateString) {
          return null;
        }
        // Split the input string by "-"
        const [year, month, day] = dateString.split("-");
        // Return the date in DD-MM-YYYY format
        return `${day}-${month}-${year}`;
      },


      // Devuelve la fecha máxima entre la fecha del proyecto y la del grupo (estan en formato string YYYY-MM-DD)
      getMaxDate(projectDate, groupDate) {
        if (! groupDate)
          return projectDate;

        if (! projectDate || (groupDate > projectDate))
          return groupDate;

        return projectDate;
      },

    },
  };
  </script>
